import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_SuicideRiskAssessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_SuicideRiskAssessment' className='file-pdf-document'>
            <div className='file-template'>
            <h3>SUICIDE RISK ASSESSMENT:
                </h3>
                <table>
                    <tr>
                    <td className='w-750'>
                            <span className='eleHeader'>1. In the past few weeks, have you wished you were dead?</span>

                            <input type='radio' id='rbWishedDead_Yes' name='rbWishedDead' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbWishedDead_No' name='rbWishedDead' className='add-only' value='No' /> No
                            <br />
                        </td>
                    </tr>
                    <tr>
                    <td className='w-750'>
                            <span className='eleHeader'>2. In the past few weeks, have you felt that you or your family would be better off if you were dead?</span>

                            <input type='radio' id='rbBetterDead_Yes' name='rbBetterDead' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbBetterDead_No' name='rbBetterDead' className='add-only' value='No' /> No
                            <br />
                        </td>
                    </tr>
                    <tr>
                    <td className='w-750'>
                            <span className='eleHeader'>3. In the past few weeks, have you been having thoughts about killing yourself?</span>

                            <input type='radio' id='rbKillYourself_Yes' name='rbKillYourself' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbKillYourself_No' name='rbKillYourself' className='add-only' value='No' /> No
                            <br />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>4. Have you ever tried to kill yourself?</span>

                            <input type='radio' id='rbTriedKill_Yes' name='rbTriedKill' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbTriedKill_No' name='rbTriedKill' className='add-only' value='No' /> No
                            <br />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>If yes, how?</td>
                    </tr>

                    <tr><td className='w-750'><textarea id='txtYesHow' name='txtYesHow' className='add-only'></textarea>
                    </td>
                    </tr>
                    <tr>
                        <td className='w-750'>When?</td></tr>

                    <tr><td className='w-750'><textarea id='txtWhen' name='txtWhen' className='add-only'></textarea>
                    </td>
                    </tr>
                    <tr>
                        <td className='w-750'>If the patient answers <b>Yes</b> to any of the above, ask the following acuity question:

                        </td>
                    </tr>
                    <tr>
                    <td className='w-750'>
                            <span className='eleHeader'>5. Are you having thoughts of killing yourself right now?</span>

                            <input type='radio' id='rbThoughtKill_Yes' name='rbThoughtKill' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbThoughtKill_No' name='rbThoughtKill' className='add-only' value='No' />  No
                            <br />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>If yes, please describe:</td>
                    </tr>
                    <tr><td className='w-750'>
                        <textarea id='txtYesDescribe' name='txtYesDescribe' className='add-only'></textarea>
                    </td>
                    </tr>
                </table>
                <p className='w-750'>
                    If client answers 'No' to all questions 1 through 4, screening is complete (not necessary to ask question #5).
                    No intervention is necessary (Note: Clinical judgement can always override a negative screen).
                </p>
                <p className='w-750'>
                    If client answers 'Yes' to any of questions 1 through 4, or refuses to answer, they are considered a positive screen. Please ask question #5 to assess acuity:
                </p>
                <table>
                    <tr>
                        <td>'Yes' to question #5 = acute positive screen (imminent risk identified)</td>
                    </tr>
                    <tr>
                        <td>
                            <ul>
                                <li>Client requires a STAT safety/full mental health evaluation and cannot leave until evaluated
                                    for safety. Keep client in sight and client in sight and remove all dangerous objects from room.
                                    Alert physician or clinician responsible for client`s care.
                                </li>
                            </ul>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td>'No' to question #5 = non-acute positive screen (potential risk identified)
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <ul>
                                <li>Client requires a brief suicide safety assessment to determine if a full mental health evaluation
                                    is needed. Client cannot leave untill evaluated for safety. Alert physician or clinician responsible for
                                    client`s care.
                                </li>
                            </ul>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Please notify RPBHS Clinical Director on the same date of all positive assessments, complete a RPBHS
                        Safety Plan, and advise parent/guardian of positive assessment for all minors.
                    </b>
                </p>
                <p className='w-750'>
                    Provide the following resources to all clients:

                </p>
                <p className='w-750'>
                    24/7 National Suicide Prevention Lifeline 1-800-273-TALK(8255);En Espanol 1-888-628-9454
                </p>
                <p className='w-750'>
                    24/7 Crisis Text Line: Text'HOME' to 74-74
                </p>

                
            </div>
        </form>

    )
}











